module.exports = __webpack_public_path__ + "img/youtube.9e59e111.svg";